import React from 'react';

import { styled } from '@mui/material/styles';
import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const StyledText = styled(Typography)`
    font-size: 25px;
    font-weight: bold;
    text-align: left;
    white-space: normal;

    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

const TitlePreview = ({ name }) => {
    if (!name) return null;
    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                gap: 1,
            }}
        >
            <StyledText>{name}</StyledText>
        </Box>
    );
};

TitlePreview.propTypes = {
    name: PropTypes.string,
};

export default TitlePreview;
